// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// constants
const homeFiltersInitialValue = {
  search: '',
  page: 0,
  size: 10,
  fromDate: '',
  toDate: '',
  sort: 'modifiedTimestamp',
  order: 'desc',
  attemptId: ''
}

export const homeSlice = createSlice({
  name: 'home',
  initialState: {
    attemptFilters: { ...homeFiltersInitialValue }
  },
  reducers: {
    setAttemptFilters(state, action) {
      state.attemptFilters = action.payload
    },
    resetAttemptFilters(state) {
      state.attemptFilters = { ...homeFiltersInitialValue }
    }
  }
})

export const { setAttemptFilters, resetAttemptFilters } = homeSlice.actions

export default homeSlice.reducer
